import React, { useState, useEffect } from 'react';
import { Form, Input, InputNumber, Popconfirm, Table, Typography, message } from 'antd';
import '../../../pages/admin/admin_assets/css/Customer.css';
import 'font-awesome/css/font-awesome.min.css';
import edit_img from '../../../pages/admin/admin_assets/img/edit_icon.svg';
import axios from 'axios';
import CreateNewQuestion from './CreateNewQuestion';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import config from '../../../config/config.js';
import { Pagination } from 'antd';

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{ margin: 0 }}
          rules={[{ required: true, message: `${title} is required!` }]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const PartnerTab = () => {
  const [form] = Form.useForm();
  const [data, setData] = useState([]);
  const [editingKey, setEditingKey] = useState('');
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0); // Store total records count
  const pageSize = 10;  // Set the number of rows per page

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${config.API_BASE_URL}/get_partner_questions.php?page=${currentPage}&pageSize=${pageSize}`);
        if (response.data.success) {
          const mappedData = response.data.questions.map((item) => ({
            key: item.id,
            text: item.question,
            q_title: item.q_title,
            q_desc: item.q_desc,
            q_type: item.q_type,
            option1: item.option1,
            option2: item.option2,
            option3: item.option3,
            option4: item.option4,
            order: item.order_question,
            status: item.question_status,
          }));
          setData(mappedData); // Set fetched data into state
          setTotalRecords(response.data.total); // Set total records count
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        message.error('Failed to fetch data.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [currentPage]); // Trigger fetching when the currentPage changes

  const isEditing = (record) => record.key === editingKey;

  const edit = (record) => {
    form.setFieldsValue({ text: '', order: '', status: '', ...record });
    setEditingKey(record.key);
  };

  const cancel = () => {
    setEditingKey('');
  };

  const save = async (key) => {
    try {
      const row = await form.validateFields();
      const newData = [...data];
      const index = newData.findIndex((item) => key === item.key);

      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...row });
        setData(newData);
        setEditingKey('');

        // Save the updated data to the backend
        await axios.put(`${config.API_BASE_URL}/update_partner_question.php`, {
          id: key,
          q_title: row.q_title,
          q_desc: row.q_desc,
          question: row.text,
          option1: row.option1,
          option2: row.option2,
          option3: row.option3,
          option4: row.option4,
          order_question: row.order,
          question_status: 'Active',
        });

        toast.success(`Question updated successfully!`);
      }
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo);
    }
  };

  const handleDelete = async (key) => {
    try {
      await axios.delete(`${config.API_BASE_URL}/delete_partner_question.php`, {
        data: { id: key },
      });

      const newData = data.filter((item) => item.key !== key);
      setData(newData);

      toast.success(`Question deleted successfully!`);
    } catch (error) {
      console.error('Error deleting question:', error);
      message.error('Failed to delete question.');
    }
  };

  const columns = [
    { 
      title: 'S.No', 
      dataIndex: 'key', 
      width: '6%',
      render: (_, __, index) => (currentPage - 1) * pageSize + index + 1, // Adjust index based on pagination
    },
    { title: 'Category', dataIndex: 'q_type', width: '10%', editable: false },
    { title: 'Title', dataIndex: 'q_title', width: '20%', editable: true },
    { title: 'Description', dataIndex: 'q_desc', width: '20%', editable: true },
    { title: 'Question', dataIndex: 'text', width: '20%', editable: true },
    { title: 'Option1', dataIndex: 'option1', width: '10%', editable: true },
    { title: 'Option2', dataIndex: 'option2', width: '10%', editable: true },
    { title: 'Option3', dataIndex: 'option3', width: '10%', editable: true },
    { title: 'Option4', dataIndex: 'option4', width: '10%', editable: true },
    { title: 'Order', dataIndex: 'order', width: '6%', editable: true, inputType: 'number' },
    { title: 'Status', dataIndex: 'status', width: '6%' },
    {
      title: '',
      dataIndex: 'operation',
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Typography.Link onClick={() => save(record.key)} style={{ marginRight: 8 }}>
              Save
            </Typography.Link>
            <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
              <a>Cancel</a>
            </Popconfirm>
          </span>
        ) : (
          <>
            <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
              <img src={edit_img} alt="" />
            </Typography.Link>

            <Typography.Link disabled={editingKey !== ''} onClick={() => handleDelete(record.key)} className="delete_icon">
              <i className="bi bi-trash3-fill"></i>
            </Typography.Link>
          </>
        );
      },
    },
  ];

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === 'order' ? 'number' : 'text',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  return (
    <div className="cutomer_sec">
      <CreateNewQuestion value={3} />
      <Form form={form} component={false}>
        <Table
          components={{ body: { cell: EditableCell } }}
          bordered
          dataSource={data}
          columns={mergedColumns}
          rowClassName="editable-row"
          pagination={false}  // Disable pagination on the Table component
          loading={loading}
        />
      </Form>
      <div className='form_pagination'>
        <Pagination 
          current={currentPage} 
          pageSize={pageSize} 
          total={totalRecords}  // Use the totalRecords from state
          onChange={setCurrentPage} 
        />
      </div>
      <ToastContainer />
    </div>
  );
};

export default PartnerTab;
